





















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from './components/common/BaseEnroll.vue'
import SecondDegreeEnrollForm from './components/SecondDegreeEnrollForm.vue'

import { ConfigStore } from '@/store/config'
import {
  fetchSecondDegreeEnroll,
  updateSecondDegreeEnroll,
  createSecondDegreeEnroll
} from '@/apis/enroll/secondDegree'
import type { SecondDegree } from '@/models/enrolls/secondDegree'
import { Enroll } from '@/models/enrolls/enroll'
import { fetchEnrollConfig } from '@/apis/enroll/enrollConfig'

@Component({
  components: { BaseEnroll, SecondDegreeEnrollForm }
})
export default class TaiwanStudent extends Vue {
  ajaxFetch = fetchSecondDegreeEnroll

  ajaxCreate: typeof createSecondDegreeEnroll = async (form) => createSecondDegreeEnroll({
      ...form,
      graduationCertificateNumber: "无需填写",
      degreeCertificateNumber: "无需填写",
    })

  ajaxUpdate: typeof updateSecondDegreeEnroll = async (form) => updateSecondDegreeEnroll({
      ...form,
      graduationCertificateNumber: "无需填写",
      degreeCertificateNumber: "无需填写",
    })

  form: SecondDegree = {
    studentId: '',
    name: '',
    sex: '',
    idCard: '',
    birthday: '',
    photoUrl: '',
    /**
     * 0: 未就业 1：已就业
     */
    isEmployed: '',
    undergraduateNumber: '',
    undergraduateMajor: '',
    graduationYear: '',
    graduationCertificateNumber: '',
    degreeCertificateNumber: '',
    firstChoice: '',
    secondChoice: '',
    mobilePhone: '',
    email: '',
    address: '',
    undergraduateHonors: '',
    personalRepresentation: '',
  }

  entrie: Enroll = {
    ID: '',
    key: '',
    title: '',
    abbr: '',
    description: '',
    startTime: '',
    endTime: '',
    disable: true,
    hidden: true,
    notice: [],
    additional: '',
  }
  nowDate = new Date();

  title = this.nowDate.getFullYear() + this.config.title
  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'second-degree')?.value ?? {}
    )
  }

  async created() {
    const entriesRaw = await fetchEnrollConfig()
    const entries: Enroll[] = entriesRaw ?? []
    this.entrie = entries.find(a => a.key === 'second-degree') ?? {
      ID: '',
      key: '',
      title: '',
      abbr: '',
      description: '',
      startTime: '',
      endTime: '',
      disable: true,
      hidden: true,
      notice: [],
      additional: '',
    }
  }
}
